import { Route, Routes } from "react-router-dom";

import { EsusContextProvider } from "@/contexts/EsusContext";
import { PermissionEnum } from "@/utils/enums/PermissionEnum";

import { PrevineBrasilDashboard } from "@/pages/esus/PrevineBrasilDashboard";
import { RegistrationManagement } from "@/pages/esus/RegistrationManagement";
import { ImportSisabPreliminaryReportData } from "@/pages/esus/ImportSisabPreliminaryReportData";
import { UsersManagement } from "@/pages/app/UsersManagement";
import { HealthTeamReport } from "@/pages/esus/HealthTeamReport";
import { Restrict } from "@/components/Restrict";
import { AttendanceReport } from "@/pages/esus/AttendanceReport";
import { EpidemicDashboard } from "@/pages/esus/EpidemicDashboard";
import { IndicatorsPanel } from "@/components/IndicatorsPanel";
import { ReterritorializationAcsDashboard } from "@/pages/esus/ReterritorializationAcsDashboard";
import { TripleViralManagement } from "@/pages/esus/TripleViralManagement";
import { MonitoringOfDiseases } from "@/pages/esus/MonitoringOfDiseases";
import { PregnancyManagement } from "@/pages/esus/PregnancyManagement";
import { ActiveVaccinationSearch } from "@/pages/esus/ActiveVaccinationSearch";
import { ProfessionalAttendanceDashboard } from "@/pages/esus/ProfessionalAttendanceDashboard";
import { Scheduler } from "@/pages/esus/Scheduling";
import { TerritorialCitizensRegistrationDashboard } from "@/pages/esus/TerritorialCitizensRegistration/TerritorialDashboard";
import { AccompanimentRegistrationReport } from "@/pages/esus/TerritorialCitizensRegistration/AccompanimentRegistrationReport";
import { IndicatorsEsf } from "@/pages/esus/Indicators/Esf";
import { IndicatorsEsb } from "@/pages/esus/Indicators/Esb";
import { IndicatorsEmulti } from "@/pages/esus/Indicators/Emulti";

export function CityEsusRoutes() {
	return (
		<EsusContextProvider>
			<Routes>
				<Route
					path="/relatorios/atendimentos-individuais/dashboard-profissional"
					element={
						<Restrict
							permissions={[PermissionEnum.ESUS_VIEW_REPORTS]}
							redirectIfNotAuthorized
						>
							<ProfessionalAttendanceDashboard />
						</Restrict>
					}
				/>
				<Route
					path="/relatorios/atendimentos-individuais/atendimentos"
					element={
						<Restrict
							permissions={[PermissionEnum.ESUS_VIEW_REPORTS]}
							redirectIfNotAuthorized
						>
							<AttendanceReport />
						</Restrict>
					}
				/>
				<Route
					path="/relatorios/agendamentos/calendario"
					element={
						<Restrict
							permissions={[PermissionEnum.ESUS_VIEW_REPORTS]}
							redirectIfNotAuthorized
						>
							<Scheduler />
						</Restrict>
					}
				/>
				<Route
					path="/relatorios/vigilancia-em-saude"
					element={
						<Restrict
							permissions={[PermissionEnum.ESUS_VIEW_REPORTS]}
							redirectIfNotAuthorized
						>
							<MonitoringOfDiseases />
						</Restrict>
					}
				/>
				<Route
					path="/relatorios/gestantes"
					element={
						<Restrict
							permissions={[PermissionEnum.ESUS_VIEW_REPORTS]}
							redirectIfNotAuthorized
						>
							<PregnancyManagement />
						</Restrict>
					}
				/>
				<Route
					path="/relatorios/triplice-viral"
					element={
						<Restrict
							permissions={[PermissionEnum.ESUS_VIEW_REPORTS]}
							redirectIfNotAuthorized
						>
							<TripleViralManagement />
						</Restrict>
					}
				/>
				<Route
					path="/relatorios/busca-ativa-vacinal"
					element={
						<Restrict
							permissions={[PermissionEnum.ESUS_VIEW_REPORTS]}
							redirectIfNotAuthorized
						>
							<ActiveVaccinationSearch />
						</Restrict>
					}
				/>
				<Route
					path="/relatorios/epidemiologicos"
					element={
						<Restrict
							permissions={[PermissionEnum.ESUS_VIEW_REPORTS]}
							redirectIfNotAuthorized
						>
							<EpidemicDashboard />
						</Restrict>
					}
				/>
				<Route
					path="/acompanhamento-territorial/dashboard"
					element={
						<Restrict
							permissions={[PermissionEnum.ESUS_VIEW_REPORTS]}
							redirectIfNotAuthorized
						>
							<TerritorialCitizensRegistrationDashboard />
						</Restrict>
					}
				/>
				<Route
					path="/acompanhamento-territorial/cadastros"
					element={
						<Restrict
							permissions={[PermissionEnum.ESUS_VIEW_REPORTS]}
							redirectIfNotAuthorized
						>
							<AccompanimentRegistrationReport />
						</Restrict>
					}
				/>
				<Route
					path="/componente-vinculo/dashboard"
					element={
						<Restrict
							permissions={[PermissionEnum.ESUS_VIEW_REPORTS]}
							redirectIfNotAuthorized
						>
							<ReterritorializationAcsDashboard />
						</Restrict>
					}
				/>
				<Route
					path="/componente-vinculo/cadastros"
					element={
						<Restrict
							permissions={[PermissionEnum.ESUS_VIEW_CITIZEN_MANAGEMENT]}
							redirectIfNotAuthorized
						>
							<RegistrationManagement />
						</Restrict>
					}
				/>
				<Route
					path="/componente-qualidade/dashboard"
					element={
						<Restrict
							permissions={[PermissionEnum.ESUS_VIEW_INDICATORS]}
							redirectIfNotAuthorized
						>
							<PrevineBrasilDashboard />
						</Restrict>
					}
				/>
				<Route
					path="/componente-qualidade/indicador/:indicator/detalhes"
					element={
						<Restrict
							permissions={[PermissionEnum.ESUS_VIEW_INDICATORS]}
							redirectIfNotAuthorized
						>
							<IndicatorsPanel />
						</Restrict>
					}
				/>
				<Route
					path="/componente-qualidade/indicador/esf/:indicator/detalhes"
					element={
						<Restrict
							permissions={[PermissionEnum.ESUS_VIEW_INDICATORS]}
							redirectIfNotAuthorized
						>
							<IndicatorsEsf />
						</Restrict>
					}
				/>
				<Route
					path="/componente-qualidade/indicador/esb/:indicator/detalhes"
					element={
						<Restrict
							permissions={[PermissionEnum.ESUS_VIEW_INDICATORS]}
							redirectIfNotAuthorized
						>
							<IndicatorsEsb />
						</Restrict>
					}
				/>
				<Route
					path="/componente-qualidade/indicador/emulti/:indicator/detalhes"
					element={
						<Restrict
							permissions={[PermissionEnum.ESUS_VIEW_INDICATORS]}
							redirectIfNotAuthorized
						>
							<IndicatorsEmulti />
						</Restrict>
					}
				/>
				<Route
					path="/componente-qualidade/desempenho-de-equipes"
					element={
						<Restrict
							permissions={[PermissionEnum.ESUS_VIEW_REPORTS]}
							redirectIfNotAuthorized
						>
							<HealthTeamReport />
						</Restrict>
					}
				/>
				<Route
					path="/componente-qualidade/importacao-dados-sisab"
					element={
						<Restrict
							permissions={[PermissionEnum.ESUS_CONFIG_DATA_IMPORT]}
							redirectIfNotAuthorized
						>
							<ImportSisabPreliminaryReportData />
						</Restrict>
					}
				/>

				<Route
					path="/gestao-de-profissionais"
					element={
						<Restrict
							permissions={[
								PermissionEnum.ESUS_VIEW_PROFESSIONAL_MANAGEMENT,
								PermissionEnum.ESUS_STATE_PROFESSIONAL_MANAGEMENT,
							]}
							redirectIfNotAuthorized
						>
							<UsersManagement />
						</Restrict>
					}
				/>
			</Routes>
		</EsusContextProvider>
	);
}
